export default __webpack_public_path__ + "static/media/polar-bear.c85499cb.png";